import produce from 'immer'

import { DEBT_PROFILE } from './types'

export const initialState = {
  loading: null,
  error: false,
  debtProfile: null,
  debtProfileStatuses: null,
  loadingEditProfile: false,
  editInformation: null,
  errorMessage: null,
  modalDataInformation: null,
  currencies: null,
  concepts: null
}

const reducer = (state = initialState, { type, payload }) => produce(state, draft => {
  switch (type) {
    case DEBT_PROFILE.GET_DEBT_PROFILE:
      draft.loading = true
      break
    case DEBT_PROFILE.SUCCESS: {
      const { debtProfileData, statusesData, currencies, concepts } = payload
      draft.loading = false
      draft.debtProfile = debtProfileData
      draft.debtProfileStatuses = statusesData
      draft.currencies = currencies
      draft.concepts = concepts
      break
    }
    case DEBT_PROFILE.ERROR:
      draft.loading = false
      draft.error = payload
      break
    case DEBT_PROFILE.EDIT_DEBT_PROFILE:
      draft.loadingEditProfile = true
      break
    case DEBT_PROFILE.EDIT_DEBT_PROFILE_INFORMATION:
      draft.editInformation = payload
      draft.loadingEditProfile = false
      break
    case DEBT_PROFILE.DEBT_PROFILE_UPDATED:
      draft.loadingEditProfile = false
      draft.debtProfile = payload
      break
    case DEBT_PROFILE.DEBT_PROFILE_MODAL_DATA_INFORMATION:
      draft.modalDataInformation = payload
      break
    case DEBT_PROFILE.CLEAR:
      return initialState
    default:
      return initialState
  }
})

export default reducer
